/**
 * Tab Configuration for PageNavbar
 *
 * To add new tabs:
 * 1. Add the tab ID to PageNavbarTab type
 * 2. Add the tab definition to DEFAULT_TABS array
 */

export type PageNavbarTab = 'run-summary' | 'repertoire-summary' | 'antibody-selection' | 'export-summary';

export interface TabDefinition {
  id: PageNavbarTab;
  label: string;
}

/**
 * Default tab configuration
 * Order matters - tabs will be displayed in this order
 */
export const DEFAULT_TABS: TabDefinition[] = [
  { id: 'run-summary', label: 'Run summary' },
  { id: 'repertoire-summary', label: 'Repertoire summary' },
  { id: 'antibody-selection', label: 'Hit selection' },
  { id: 'export-summary', label: 'Export summary' },
];
